import { Outlet } from "react-router";
import { useNavigate } from "react-router-dom";
import { UserTabLayoutConfig } from "../routes/layout.config";
import { useLoading } from "../shared/context/LoadingContext";
import { AppHeader } from "../shared/uikit/AppHeader/AppHeader";
import { TabBar } from "../shared/uikit/tapBar/tabBar";
import { AnimatedPageTransition } from "../shared/uikit/AnimatedPageTransition/AnimatedPageTransition";
import { Loader } from "../shared/uikit/Loader/Loader";

interface TabLayoutProps {
  children?: React.ReactNode;
}

export const UserTabLayout = ({ children }: TabLayoutProps) => {
  const navigate = useNavigate();
  const config = UserTabLayoutConfig;
  const { isLoading } = useLoading();

  return (
    <div>
      <header>
        <AppHeader
          onClickHandler={config.headerHandlers(navigate).onClickBack}
        />
      </header>

      <main>
        <AnimatedPageTransition>
          {isLoading && <Loader />} {children ?? <Outlet />}
        </AnimatedPageTransition>
      </main>

      <footer>
        <TabBar
          {...config.tabBarHandlers(navigate)}
          ScanText={"Scan"}
          DevicesText={"Devices"}
          SettingsText={"Profile"}
        />
      </footer>
    </div>
  );
};
